module.exports = __webpack_public_path__ + "static/media/int-bg-8.dc49ab94.png";